/**
 * URL-Based Variant Savings Update
 * Bypasses theme events by watching for URL changes.
 */
(function() {
  const updateSavings = () => {
    const badge = document.querySelector('[data-product-savings-badge]');
    const percentEl = document.querySelector('[data-price-off-amount]');
    const parent = document.querySelector('[data-price-off]');
    
    // 1. Get current variant ID from URL
    const urlParams = new URLSearchParams(window.location.search);
    const currentVariantId = urlParams.get('variant');

    // 2. Find Product Data
    const productJson = document.querySelector('[data-product-json], #ProductJson-product-template, script[type="application/json"][data-product-json]');
    
    if (!productJson || !currentVariantId) return;

    try {
      const product = JSON.parse(productJson.textContent);
      const variant = product.variants.find(v => v.id == currentVariantId);

      if (variant && variant.compare_at_price > variant.price) {
        const savings = variant.compare_at_price - variant.price;
        const savingsPercent = Math.round((savings / variant.compare_at_price) * 100);
        
        // Format Money (Manual fallback to avoid Shopify.formatMoney errors)
        const format = (window.theme && theme.moneyFormat) ? theme.moneyFormat : "€{{amount}}";
        let formatted;
        if (window.Shopify && Shopify.formatMoney) {
          formatted = Shopify.formatMoney(savings, format);
        } else {
          formatted = '€' + (savings / 100).toFixed(2);
        }

        // Update DOM
        if (badge) {
          badge.innerHTML = 'SAVE ' + formatted.replace('.00', '');
          badge.style.setProperty('display', 'inline', 'important');
        }
        if (percentEl) percentEl.textContent = savingsPercent + '%';
        if (parent) parent.classList.remove('hidden');
        
      } else {
        // Hide if no discount
        if (badge) badge.style.display = 'none';
        if (parent) parent.classList.add('hidden');
      }
    } catch (e) {
      console.error("Savings Update Error:", e);
    }
  };

  // Run on load
  if (document.readyState === 'complete') {
    updateSavings();
  } else {
    window.addEventListener('load', updateSavings);
  }

  // FAIL-SAFE: Watch the URL for changes every 500ms 
  // (Most reliable way when other scripts are crashing)
  let lastUrl = location.href;
  setInterval(() => {
    if (location.href !== lastUrl) {
      lastUrl = location.href;
      updateSavings();
    }
  }, 500);

  // Also try to hook into theme events if they happen to work
  document.addEventListener('variant:change', updateSavings);
  document.addEventListener('theme:variant:change', updateSavings);
})();